import { SparkThemeName } from '@spark-web/theme';

const SUPPORTED_SPARK_THEMES = new Set<SparkThemeName>(['brighte', 'pantheon', 'bravo']);

export const toSparkTheme = (name?: string | null): SparkThemeName =>
  SUPPORTED_SPARK_THEMES.has(name as SparkThemeName) ? (name as SparkThemeName) : 'brighte';
